export default "__VITE_ASSET__BwBFVc8___"